import React, { useState } from 'react';
import './statementHistoryDownload.css';
import { ButtonHeading } from 'components';
import { AiOutlineMail } from 'react-icons/ai';
import { LiaDownloadSolid } from 'react-icons/lia';

const StatementHistoryDownload = ({ statements }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Default sample data
  const defaultStatements = [
    {
      id: 1,
      dateRange: '01 Dec 2025 - 12 Feb 2026',
      type: 'Bank Statement',
      format: 'XLS',
      fileSize: '0.025 MB',
      requestedOn: '12 FEB 2026, 11:32 PM',
      status: 'Successful'
    },
    {
      id: 2,
      dateRange: '01 Dec 2025 - 12 Feb 2026',
      type: 'Bank Statement',
      format: 'PDF',
      fileSize: '0.108 MB',
      requestedOn: '12 FEB 2026, 06:27 PM',
      status: 'Successful'
    },
    {
      id: 3,
      dateRange: '01 Nov 2025 - 31 Jan 2026',
      type: 'Bank Statement',
      format: 'PDF',
      fileSize: '0.108 MB',
      requestedOn: '09 FEB 2026, 03:46 PM',
      status: 'Successful'
    },
    {
      id: 4,
      dateRange: '01 Oct 2025 - 31 Dec 2025',
      type: 'Bank Statement',
      format: 'CSV',
      fileSize: '0.089 MB',
      requestedOn: '05 FEB 2026, 09:15 AM',
      status: 'Successful'
    }
  ];

  const statementList = statements || defaultStatements;

  // Filter statements based on search
  const filteredStatements = statementList.filter(statement =>
    statement.dateRange.toLowerCase().includes(searchTerm.toLowerCase()) ||
    statement.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    statement.format.toLowerCase().includes(searchTerm.toLowerCase()) ||
    statement.requestedOn.toLowerCase().includes(searchTerm.toLowerCase()) ||
    statement.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEmailClick = (statement) => {
    console.log('Email statement:', statement);
    // Add your email logic here
  };

  const handleDownloadClick = (statement) => {
    console.log('Download statement:', statement);
    // Add your download logic here
  };

  return (
    <>
      <ButtonHeading
        title="Downloads"
        buttonTitle="Add Account"
      />

      <div className="__accountMain_bxs sh-Main">
        <div className="__connectDetail_otr">
          <div className="container-fluid">
            <div className="sh-table-container sh-sub-main">
              {/* Info Banner */}
              <div className="sh-info-banner">
                <div className="sh-info-item">
                  <span className="sh-bullet">•</span>
                  <span>Reports will be available to download for 7 days.</span>
                </div>
                <div className="sh-info-item">
                  <span className="sh-bullet">•</span>
                  <span>Reports will contain no more than 1 lakh of the most recent transactions.</span>
                </div>
                <div className="sh-info-item">
                  <span className="sh-bullet">•</span>
                  <span>Only files up to 5 MB can be sent via email.</span>
                </div>
              </div>

              {/* Table */}
              <div className="sh-table-wrapper">
                {filteredStatements.length > 0 ? (
                  filteredStatements.map((statement) => (
                    <div key={statement.id} className="sh-card">
                      <div className="sh-card-content">
                        <div className="sh-card-item">
                          <div className="sh-cell-main">{statement.dateRange}</div>
                          <div className="sh-cell-sub">Date Range</div>
                        </div>
                        <div className="sh-card-item">
                          <div className="sh-cell-main">{statement.type}</div>
                          <div className="sh-cell-sub">Type</div>
                        </div>
                        <div className="sh-card-item">
                          <div className="sh-cell-main">{statement.format}</div>
                          <div className="sh-cell-sub">Format</div>
                        </div>
                        <div className="sh-card-item">
                          <div className="sh-cell-main">{statement.fileSize}</div>
                          <div className="sh-cell-sub">File Size</div>
                        </div>
                        <div className="sh-card-item">
                          <div className="sh-cell-main">{statement.requestedOn}</div>
                          <div className="sh-cell-sub">Requested on</div>
                        </div>
                        <div className="sh-card-item">
                          <div className="sh-cell-main sh-status-success">{statement.status}</div>
                          <div className="sh-cell-sub">Status</div>
                        </div>
                        <div className="sh-card-item sh-card-actions">
                          <div className="sh-action-buttons">
                            <button
                              className="sh-btn-email"
                              onClick={() => handleEmailClick(statement)}
                            >
                              Email <AiOutlineMail />
                            </button>
                            <button
                              className="sh-btn-download"
                              onClick={() => handleDownloadClick(statement)}
                            >
                              Download <LiaDownloadSolid />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="sh-empty-state">
                    <p>No statements found</p>
                    <small>Check back later for your download history</small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatementHistoryDownload;